<template>

	<div>

		<span>

			<input class="col-12 password" placeholder="" autocomplete="off" :id="name" type="password" :name="name" v-model="password" required v-if="!showPassword">

			<input class="col-12 password" placeholder="" autocomplete="off" :id="name" type="text" :name="name" v-model="password" required v-else>

			<div class="show" @click.prevent="togglePassword"><i :class="imageClass" class="fas fa-eye"></i></div>

			<ul class="security" v-if="useMeter">

				<h4>Password security</h4>

				<li v-for="n in 5">

					<span class="checked" v-if="passwordStrength >= n"></span>

					<span class="unchecked" v-else></span>

				</li>

				<div class="tooltips" v-if="useMeter">

					<img src="/images/tip.svg" alt="Password tips">

					<div class="tooltips__msg">

						<p>Use a mix of alphanumeric characters (letters and numbers) and symbols:</p>

						<ul>
							<li>Uppercase (capital) letters. Examples: A, E, R</li>
							<li>Lowercase (small) letters. Examples: a, e, r</li>
							<li>Numbers. Examples: 2, 6, 7</li>
							<li>Symbols and special characters. Examples: ! @ & *</li>
						</ul>

					</div>

				</div>

			</ul>

		</span>

	</div>

</template>

<script>
    export default {
        name: "password",
        data() {
            return {
                password: '',
                showPassword: false,
            };
        },
        computed: {
            imageClass() {
                return this.showPassword ? 'copper' : 'grey';
            },
            passwordStrength() {
                let strength = 0;
                let minRequired = false;

                if (String(this.password).length >= 6
                    && String(this.password).match(/(.*[a-z].*)/)
                    && String(this.password).match(/(.*[A-Z].*)/)
                    && String(this.password).match(/(.*\d.*)/)) {
                    minRequired = true;
                    strength = 1;
                }

                if (minRequired) {
                    if (String(this.password).match(/(.*[!@#$%^&*].*)/)) {
                        strength += 1;
                    }

                    if (String(this.password).length > 10) {
                        strength += 1;
                    }

                    if (String(this.password).length > 16) {
                        strength += 1;
                    }

                    if (String(this.password).match(/[!@#$%^&*]/g) !== null && String(this.password).match(/[!@#$%^&*]/g).length > 2) {
                        strength += 1;
                    }
                }

                return strength;
            }
        },
		watch:{
          password(value){
              this.$emit('change', {
                  passwordStrength: this.passwordStrength,
				  valid: this.passwordStrength >= 1,
			  });
              this.$emit('input', value);
		  },
		  value(value){
              this.password = value;
		  }
		},
        methods: {
            togglePassword() {
                this.showPassword = !this.showPassword;
            }
        },
        props: ['name', 'use-meter', 'value'],
    }
</script>

<style scoped>

</style>
